import React from "react";
import { Badge, Row, Col } from "react-bootstrap";
import { CommonModal } from "../Input";
import DataTable from "../table/DataTable";

const CashVaultDetailsModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  const summaryData = [
    { label: "Created Date", value: transaction.dateTime },
    { label: "ID", value: transaction.id },
    { label: "Branch", value: transaction.branch },
    { label: "Type", value: transaction.type },
    { label: "Reason", value: transaction.reason },
    { label: "Total Amount", value: `${transaction.amount} SGD` },
  ];

  const columns = [
    {
      label: "IMAGE",
      key: "image",
      className: "ps-4 text-center",
      cellClassName: "ps-4 text-center",
      style: { width: "100px" },
      render: (item) => (
        <div
          className="d-flex align-items-center justify-content-center border rounded bg-white overflow-hidden mx-auto"
          style={{ width: "45px", height: "30px", borderColor: "#eee" }}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.label}
              style={{ width: "100%", height: "auto" }}
            />
          ) : (
            <div className="text-muted fs-8 fw-bold">$</div>
          )}
        </div>
      ),
    },
    {
      label: "DENOMINATION",
      key: "label",
      style: { width: "250px" },
      render: (item) => (
        <span className="fs-13 fw-bold text-black">{item.label}</span>
      ),
    },
    {
      label: "INVENTORY",
      key: "inventory",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "150px" },
      render: (item) => (
        <div className="d-flex align-items-center justify-content-center">
          {item.inventory !== "-" && (
            <div
              className="rounded-circle me-1"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#34D399",
              }}
            />
          )}
          {item.inventory !== "-" ? (
            <span className="fw-bold fs-12 text-black">{item.inventory}</span>
          ) : (
            <span className="text-muted">—</span>
          )}
        </div>
      ),
    },
    {
      label: "QUANTITY",
      key: "quantity",
      className: "text-center",
      cellClassName: "text-center",
      style: { width: "200px" },
      render: (item) => (
        <div className="d-flex justify-content-center">
          <div
            className="form-control text-center py-1 d-flex align-items-center justify-content-center"
            style={{
              height: "36px",
              width: "100px",
              fontSize: "13px",
              borderColor: "#E2E8F0",
              borderRadius: "8px",
              backgroundColor: "#fff",
            }}
          >
            {item.qty}
          </div>
        </div>
      ),
    },
    {
      label: "TOTAL",
      key: "total",
      className: "pe-4 text-end",
      cellClassName: "pe-4 text-end",
      style: { width: "180px" },
      render: (item) => (
        <div className="fw-bold fs-13 text-black">
          SGD{" "}
          {(item.value * item.qty).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })}
        </div>
      ),
    },
  ];

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Cash Vault Details"
      fullscreen={true}
      headerClassName="px-4 py-3"
    >
      <div>
        <div
          className="p-4 mb-3 border border-light"
          style={{ borderRadius: "12px", backgroundColor: "#FAFAFA" }}
        >
          <Row className="g-4">
            {summaryData.map((item, idx) => (
              <Col md={4} key={idx} className="mb-md-0 mb-3">
                <div className="text-muted fs-11 mb-2">{item.label}</div>
                <div className="fw-bold text-black fs-13">{item.value}</div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="d-flex justify-content-end gap-2 mb-3">
          <Badge
            bg="light"
            className="text-black border px-3 py-2 d-flex align-items-center"
            style={{
              borderRadius: "20px",
              fontSize: "12px",
              backgroundColor: "#F1F5F9",
              borderColor: "#E2E8F0",
              height: "40px",
            }}
          >
            <span className="text-muted me-2">Total cash:</span>
            <span className="fw-bold" style={{ color: "#1E40AF" }}>
              SGD {transaction.totalCash}
            </span>
          </Badge>
          <Badge
            bg="light"
            className="text-black border px-3 py-2 d-flex align-items-center"
            style={{
              borderRadius: "20px",
              fontSize: "12px",
              backgroundColor: "#F1F5F9",
              borderColor: "#E2E8F0",
              height: "40px",
            }}
          >
            <span className="text-muted me-2">Total to Pay:</span>
            <span className="fw-bold" style={{ color: "#1E40AF" }}>
              SGD {transaction.totalToPay}
            </span>
          </Badge>
        </div>

        <div className="card shadow-none rounded-4 overflow-hidden border border-light mb-4">
          <DataTable
            columns={columns}
            data={transaction.denominations || []}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default CashVaultDetailsModal;
